import React from 'react';
import classNames from 'classnames';

import iconChatAtivo from '../../../../assets/images/Icon_chat_ativo.svg';

const voiceItems = [
  {
    title: 'Transf. Ramal',
    icon: 'icon_ramal',
    type: 'VoiceTransferirRamalInternoExterno',
    enabled: true,
  },
  {
    title: 'Tocar Áudio',
    icon: 'icon_asr',
    type: 'VoiceTTSAudio',
    enabled: true,
  },
  // {
  //   title: 'Venda',
  //   icon: 'icon_carrinho',
  //   type: 'VoiceConfirmarVenda',
  //   enabled: true,
  // },
  {
    title: 'Áudio + Reconhecimento de Voz',
    icon: 'icon_asr',
    type: 'VoiceTTSAudioASR',
    enabled: true,
  },
  {
    title: 'Finalizar Atendimento',
    icon: 'icon_email',
    type: 'VoiceFinalizarAtendimento',
    enabled: true,
  },
  {
    title: 'Transf. Operador',
    icon: 'icon_humano',
    type: 'VoiceTransferirRamalLocalizadorVendedor',
    enabled: true,
  },
  {
    title: 'Agendar Ligação',
    icon: 'icon_agendar',
    type: 'VoiceAgendarMailing',
    enabled: true,
  },
  {
    title: 'Áudio + Reconh. de Dígitos',
    icon: 'icon_dtmf',
    type: 'VoiceTTSAudioDTMF',
    enabled: true,
  },
  // {
  //   title: 'Webservice',
  //   icon: 'icon_webservice',
  //   type: 'VoiceWebservice',
  //   enabled: true,
  // },
  {
    title: 'Enviar SMS',
    icon: 'icon_sms',
    type: 'VoiceSMS',
    enabled: true,
  },
  {
    title: 'API',
    icon: 'icon_webservice',
    type: 'VoiceWebApiList',
    enabled: true,
  },
  // {
  //   title: 'Pesquisar',
  //   icon: 'icon_formulario',
  //   type: 'VoicePesquisarMailing',
  //   enabled: true,
  // },
  // {
  //   title: 'Inserir Mailing',
  //   icon: 'icon_email',
  //   type: 'VoiceInserirMailing',
  //   enabled: true,
  // },
  // {
  //   title: 'Email',
  //   icon: 'icon_email',
  //   type: 'VoiceEmail',
  //   enabled: true,
  // },
  // {
  //   title: 'Pular STEP',
  //   icon: 'icon_pulo_step',
  //   type: 'VoicePularStep',
  //   enabled: true,
  // },
];

const SubMenuVoiceItems = ({
  handleDragStart,
  handleDragEnd,
  draggingType,
  isActive,
}) => {
  return (
    <div
      className={`menu-criador-submenu submenu-blocos submenu-voice-bot-blocos ${
        isActive ? '' : 'hidden'
      }`}
    >
      <div className="header-menu-criador-submenu-blocos">
        <div className="container-header-menu-blocos">
          <img src={iconChatAtivo} alt="Icon menu open" />
        </div>
      </div>

      <ul className="creator-menu">
        <li
          className="header"
          data-toggle="collapse"
          data-target="#creator-menu--blocos-voice-bot"
        >
          Voicebot
        </li>

        <ul id="creator-menu--blocos-voice-bot" className="collapse show">
          {voiceItems.map((item) => (
            <li key={item.type}>
              <span
                className={classNames({
                  'd-none': draggingType !== item.type,
                  'dragging-overlay': true,
                })}
              />
              <input
                type="radio"
                id={`radio_blocos_voice-bot-${item.type}`}
                name="radio_blocos_voice-bot"
              />
              <label
                htmlFor={`radio_blocos_voice-bot-${item.type}`}
                draggable
                onDragStart={(e) => handleDragStart(e, item.type)}
                onDragEnd={(e) => handleDragEnd(e)}
                className={classNames({
                  dragging: draggingType === item.type,
                })}
              >
                <img
                  className="no-drag"
                  src={`/assets/images/icons/${item.icon}.svg`}
                  alt=""
                />
                <p>{item.title}</p>
              </label>
            </li>
          ))}
        </ul>
      </ul>
    </div>
  );
};

export default SubMenuVoiceItems;
